import React from "react";
import "../styles/privacyPolicy.css";
import { MdEmail } from "react-icons/md";
import { FaGlobe } from "react-icons/fa";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container theme--2">
      <header className="privacy-header">
        <h1>Data Privacy Policy</h1>
        <p>
          Effective Date: <strong>October 25, 2025</strong>
        </p>
      </header>

      <section className="privacy-section">
        <h2>1. Introduction</h2>
        <p>
          This Data Privacy Policy applies to <strong>Matel Trading Motors</strong> and its subsidiaries, 
          referred to as “we,” “our,” and “us.” By using our website (<strong>www.mateltradingmotors.com</strong>), 
          you agree to the terms outlined in this Policy. This Policy outlines how we collect, use, and 
          protect personal information in compliance with the Data Protection Act of Kenya and applicable 
          international standards.
        </p>
        <p>
         Matel Trading Motors is committed to safeguarding your privacy and ensuring that any personal 
          data collected is handled lawfully, transparently, and securely.
        </p>
      </section>

      <section className="privacy-section">
        <h2>2. Personal Information</h2>
        <p>
          We collect personal information only when it is knowingly and voluntarily submitted by you. 
          For example, we may collect your information to process your vehicle purchase, respond to enquiries, 
          or provide additional services. We adhere to Kenyan privacy regulations and maintain transparency 
          on how this information is used.
        </p>
      </section>

      <section className="privacy-section">
        <h2>3. Use of Information</h2>
        <p>Your personal information may be used for the following purposes:</p>
        <ul>
          <li>To verify your identity and provide services;</li>
          <li>To detect and prevent fraud or misuse;</li>
          <li>To manage orders, deliveries, and warranties;</li>
          <li>To conduct market research and improve our services;</li>
          <li>To comply with legal and audit obligations;</li>
          <li>For marketing purposes, where consent has been provided.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>4. Registered Members</h2>
        <p>
          Registration on our website is optional. However, certain services require it. When registering, 
          you may need to provide your name, contact details, and preferences for receiving promotional 
          updates. You may access or edit your information anytime through your account dashboard.
        </p>
      </section>

      <section className="privacy-section">
        <h2>5. Disclosure of Information</h2>
        <p>
          We may disclose personal information to trusted service providers assisting in order processing, 
          logistics, or marketing. All service providers are contractually bound to maintain confidentiality 
          and comply with data protection laws.
        </p>
        <p>
          Personal data may also be disclosed:
        </p>
        <ul>
          <li>When required by law or regulatory authorities;</li>
          <li>To protect our business interests or legal rights;</li>
          <li>To prevent or investigate fraud or data misuse.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>6. Data Security</h2>
        <p>
          We implement robust security measures to protect personal data against unauthorized access, loss, 
          or misuse. These include:
        </p>
        <ul>
          <li>Secure server environments and encryption;</li>
          <li>Limited employee access to personal data;</li>
          <li>Regular security audits and compliance checks;</li>
          <li>Strict protocols for data retention and disposal.</li>
        </ul>
        <p>
          Despite our best efforts, no online transmission is completely secure. Therefore, users share 
          information with us at their own risk.
        </p>
      </section>

      <section className="privacy-section">
        <h2>7. Direct Marketing</h2>
        <p>
          If you have subscribed to receive marketing updates, we may contact you about our vehicles, offers, 
          and services. You can opt out anytime by clicking “Unsubscribe” in emails or replying “STOP” to SMS messages.
        </p>
      </section>

      <section className="privacy-section">
        <h2>8. Policy Updates</h2>
        <p>
         Matel Trading Motors reserves the right to update or amend this Data Privacy Policy as needed. 
          Updated versions will be posted on our website with a new effective date.
        </p>
      </section>

      <section className="privacy-section">
        <h2>9. Contact Us</h2>
        <p>
          For questions, access requests, or to update your preferences, please contact:
        </p>
  <div className="contact-links">
    <p>
      <MdEmail className="contact-icon" />
      <a href="mailto:info@mateltradingmotors.com">info@mateltradingmotors.com</a>
    </p>
    <p>
      <FaGlobe className="contact-icon" />
      <a href="https://www.mateltradingmotors.com" target="_blank" rel="noreferrer">
        www.mateltradingmotors.com
      </a>
    </p>
  </div>
      </section>

      
    </div>
  );
};

export default PrivacyPolicy;
